export const categoryMap = [
  {
    id: "1",
    name: {
      en: "Common purpose & Commitment",
      vn: "Sứ mệnh chung & cam kết đồng lòng",
    },
    statements: [
      {
        id: "1.1",
        text: {
          en: "The team has a meaningful and clear purpose/objective",
          vn: "Nhóm có mục đích/mục tiêu rõ ràng và có ý nghĩa",
        },
      },
      {
        id: "1.2",
        text: {
          en: "All team members commit to the purpose/objective",
          vn: "Tất cả các thành viên trong nhóm cam kết thực hiện mục đích/mục tiêu",
        },
      },
      {
        id: "1.3",
        text: {
          en: "The purpose/objective is defined with the team",
          vn: "Mục đích/ mục tiêu được cả nhóm xác định cùng nhau",
        },
      },
      {
        id: "1.4",
        text: {
          en: "Team members work hard for the team’s purpose/objective",
          vn: "Các thành viên trong nhóm làm việc chăm chỉ vì mục đích/mục tiêu của nhóm",
        },
      },
    ],
  },
  {
    id: "2",
    name: {
      en: "Trust & Mutual Respect",
      vn: "Tin tưởng & Tôn trọng lẫn nhau",
    },
    statements: [
      {
        id: "2.1",
        text: {
          en: "Team members trust each other",
          vn: "Các thành viên trong nhóm tin tưởng lẫn nhau",
        },
      },
      {
        id: "2.2",
        text: {
          en: "Team members respect each other",
          vn: "Các thành viên trong nhóm tôn trọng lẫn nhau",
        },
      },
      {
        id: "2.3",
        text: {
          en: "Team members give enough feedback to each other",
          vn: "Các thành viên trong nhóm đưa ra phản hồi đầy đủ cho nhau",
        },
      },
      {
        id: "2.4",
        text: {
          en: "Conflicts are resolved without damaging the relationship",
          vn: "Xung đột được giải quyết mà không làm tổn hại đến mối quan hệ",
        },
      },
    ],
  },
  {
    id: "3",
    name: {
      en: "Communication",
      vn: "Giao tiếp",
    },
    statements: [
      {
        id: "3.1",
        text: {
          en: "Team members communicate effectively (=timely/clearly)",
          vn: "Các thành viên trong nhóm giao tiếp hiệu quả (= kịp thời/rõ ràng)",
        },
      },
      {
        id: "3.2",
        text: {
          en: "Team members adjust their communication based on who is receiving the message",
          vn: "Các thành viên trong nhóm điều chỉnh cách giao tiếp để phù hợp với người nhận thông điệp ",
        },
      },
      {
        id: "3.3",
        text: {
          en: "Team members communicate properly (=tone of voice/choice of words)",
          vn: "Các thành viên trong nhóm giao tiếp đúng cách (=giọng điệu/lựa chọn từ ngữ)",
        },
      },
      {
        id: "3.4",
        text: {
          en: "Team members listen to each other",
          vn: "Các thành viên trong nhóm lắng nghe nhau",
        },
      },
    ],
  },
  {
    id: "4",
    name: {
      en: "Accountability & Ownership",
      vn: "Cam kết trách nhiệm & Sự tự chủ trong công việc",
    },
    statements: [
      {
        id: "4.1",
        text: {
          en: "Team members show accountability for team results",
          vn: "Các thành viên trong nhóm thể hiện trách nhiệm về kết quả của nhóm",
        },
      },
      {
        id: "4.2",
        text: {
          en: "Work continues as normal if there is no leader around",
          vn: "Công việc vẫn tiếp diễn kể cả khi người quản lý vắng mặt",
        },
      },
      {
        id: "4.3",
        text: {
          en: "Initiative is appreciated in this team",
          vn: "Đội ngũ đánh giá cao những sáng kiến",
        },
      },
      {
        id: "4.4",
        text: {
          en: "We have a team of team players",
          vn: "Chúng tôi có một đội ngũ những người biết phối hợp hiệu quả",
        },
      },
    ],
  },
  {
    id: "5",
    name: {
      en: "Shared & Well-working processes",
      vn: "Quy trình làm việc chung rõ ràng, hiệu quả",
    },
    statements: [
      {
        id: "5.1",
        text: {
          en: "This team functions as a well-oiled machine",
          vn: " Đội ngũ vận hành một cách trơn tru ",
        },
      },
      {
        id: "5.2",
        text: {
          en: "Team members know what is expected of them",
          vn: "Các thành viên hiểu rõ vai trò của mình",
        },
      },
      {
        id: "5.3",
        text: {
          en: "Team processes are owned by the team",
          vn: "Quy trình làm việc do chính tập thể nhóm tự quyết định và quản lý.",
        },
      },
      {
        id: "5.4",
        text: {
          en: "This team has a high velocity and output",
          vn: "Đội ngũ làm việc rất nhanh chóng và hiệu quả",
        },
      },
    ],
  },
  {
    id: "6",
    name: {
      en: "Continuous Learning & Improving",
      vn: "Không ngừng học hỏi & cải tiến",
    },
    statements: [
      {
        id: "6.1",
        text: {
          en: "Our team is periodically reflecting on its performance as a team",
          vn: "Cả nhóm cùng nhau đánh giá hiệu suất định kỳ",
        },
      },
      {
        id: "6.2",
        text: {
          en: "In this team, we are always looking for better ways",
          vn: "Chúng tôi luôn tìm cách cải tiến",
        },
      },
      {
        id: "6.3",
        text: {
          en: "All team members keep on learning (e.g from their mistakes)",
          vn: "Các thành viên trong nhóm không ngừng học hỏi (ví dụ: học từ sai lầm của họ)",
        },
      },
      {
        id: "6.4",
        text: {
          en: "Our team handles changing circumstances effectively",
          vn: "Đội ngũ chúng tôi xử lý hiệu quả những tình huống thay đổi",
        },
      },
    ],
  },
  {
    id: "7",
    name: {
      en: "The right mix",
      vn: "Sự kết hợp chặt chẽ trong đội ngũ",
    },
    statements: [
      {
        id: "7.1",
        text: {
          en: "Roles in the team are complementary",
          vn: "Vai trò của các thành viên trong nhóm bổ sung hài hoà cho nhau",
        },
      },
      {
        id: "7.2",
        text: {
          en: "We have all the necessary competencies in the team to achieve the team’s purpose/objective",
          vn: "Chúng tôi có tất cả các năng lực cần thiết trong nhóm để đạt được mục đích/mục tiêu của nhóm",
        },
      },
      {
        id: "7.3",
        text: {
          en: "Team members appreciate one another’s strengths",
          vn: "Các thành viên trong nhóm đánh giá cao điểm mạnh của nhau",
        },
      },
      {
        id: "7.4",
        text: {
          en: "When one team member is missing, the work can still get done",
          vn: "Khi thiếu một thành viên trong nhóm, công việc vẫn có thể hoàn thành",
        },
      },
    ],
  },
  {
    id: "8",
    name: {
      en: "Relationship other teams & the company",
      vn: "Mối quan hệ với những đội ngũ khác và với công ty",
    },
    statements: [
      {
        id: "8.1",
        text: {
          en: "What our team does, has a positive impact on the company’s results",
          vn: "Công việc của nhóm đều tác động tích cực đến kết quả của công ty. ",
        },
      },
      {
        id: "8.2",
        text: {
          en: "Our collaborations with other teams are productive, worthwhile, and yield good results",
          vn: "Chúng tôi hợp tác hiệu quả, có giá trị và mang lại kết quả tốt",
        },
      },
      {
        id: "8.3",
        text: {
          en: "Our team has established trusting and supportive relationships with other teams",
          vn: "Nhóm của chúng tôi đã thiết lập mối quan hệ tin cậy và hỗ trợ với các nhóm khác",
        },
      },
      {
        id: "8.4",
        text: {
          en: "We are able to resolve conflicts with other teams collaboratively",
          vn: "Chúng tôi có thể giải quyết xung đột với các nhóm khác một cách hợp tác",
        },
      },
    ],
  },
];
